import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { ProductTomos } from './components/ProductTomos';
import { RecipeCarousel } from './components/RecipeCarousel';
import { Bonuses } from './components/Bonuses';
import { CoachSection } from './components/CoachSection';
import { Testimonials } from './components/Testimonials';
import { UrgencyBanner } from './components/UrgencyBanner';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="flex w-full min-h-full flex-col bg-white font-sans" data-id="element-0" data-mp="28te1n9vnj3li">
      <Hero data-id="element-1" data-mp="23vkzqt1dsvr1" />
      <PainPoints data-id="element-2" data-mp="23w4g45bdvc2y" />
      <Solution data-id="element-3" data-mp="23ujmchww7x65" />
      <ProductTomos data-id="element-4" data-mp="23v2rsz5cwt3a" />
      <RecipeCarousel data-id="element-5" data-mp="23ti6m04xmmi3" />
      <Bonuses data-id="element-6" data-mp="3ikh8ubu2yx01" />
      <CoachSection data-id="element-7" data-mp="3ikqwhsrnks2k" />
      <Testimonials data-id="element-8" data-mp="3ijfvu1ti80fo" />
      <UrgencyBanner data-id="element-9" data-mp="3ihv0i9zd8dgr" />
      <FAQSection data-id="element-10" data-mp="3mlj6io8cn0zw" />
      <FinalCTA data-id="element-11" data-mp="3mkrd9k285fcs" />
      <Footer data-id="element-12" data-mp="3mkhofzsx1e8o" />
      <StickyMobileCTA data-id="element-13" data-mp="3mjztr7lwj82v" />
      <RecentPurchaseToast data-id="element-14" data-mp="3mj6hjr46bqdc" />
      <div className="h-16 sm:hidden" aria-hidden="true" data-id="element-15" data-mp="3rbra6pbcfxfa" />
    </div>;
}